import { render, staticRenderFns } from "./topic-details.vue?vue&type=template&id=7dbeee0b&"
import script from "./topic-details.vue?vue&type=script&lang=js&"
export * from "./topic-details.vue?vue&type=script&lang=js&"
import style0 from "./topic-details.vue?vue&type=style&index=0&id=7dbeee0b&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports